<template>
  <div class="applets-notes">
    <el-Scrollbar style="width: 100%;" :native="false">
      <div class="decoration-wrap clearfix">
        <div class="box">
          <h3 class="title">模块选择区域</h3>
          <p class="tips">
            模块选择区可通过选择相应的模块进行拖拽到浏览区域，在浏览区
            选中模块，在模块的右边就会弹出模块编辑页对模块进行排序和编 辑设置。
          </p>
          <div class="modules clearfix">
            <el-Scrollbar
              style="height: 100%"
              view-style="height: 100%"
              :native="false"
            >
              <draggable
                v-model="componentSelect"
                v-bind="drag1"
                style="height: 100%;"
              >
                <transition-group name="flip-list">
                  <div
                    class="component"
                    v-for="item in componentSelect"
                    :key="item.title"
                  >
                    <div class="drag">
                      <fragment :is="item.component" />
                    </div>
                    <h3 class="sub-title">
                      {{ item.title }}
                    </h3>
                  </div>
                </transition-group>
              </draggable>
            </el-Scrollbar>
          </div>
        </div>
        <div class="box no-bor">
          <h3 class="title">模块可视化编辑浏览区域</h3>
          <p class="tips">
            该区域是一个可视化编辑的显示区域，鼠标在可视化编辑区域内点
            击对应的模块后，模块的右边就会弹出模块的编辑设置页面，当设
            置好模块数据时，该区域就会显示实时的编辑效果页面。(双击移除模块)
          </p>
          <div class="modules">
            <div class="home-bg__frame">
              <div class="block">
                <el-Scrollbar style="height: 100%" :native="false">
                  <draggable
                    v-bind="drag2"
                    v-model="componentShow"
                    @choose="chooseItem"
                    style="height: 100%;"
                  >
                    <div
                      class="component"
                      v-for="item in componentShow"
                      :key="item.title"
                      :data-index="item.index"
                    >
                      <div class="drag">
                        <fragment
                          :is="item.component"
                          :ref="`view${item.index}`"
                        />
                      </div>
                    </div>
                  </draggable>
                </el-Scrollbar>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <h3 class="title">模块属性设置区域</h3>
          <p class="tips">
            模块属性设置主要对各模块的图片上传的像素大小，链接，文本内
            容，排序，添加，保存，删除等进行设置。(拖拽排序~！)
          </p>
          <div class="modules">
            <el-Scrollbar style="height: 100%" :native="false">
              <el-collapse v-model="activeName" accordion @change="handleCheck">
                <el-collapse-item title="轮播banner图模块" name="1">
                  <div class="editor">
                    <draggable
                      v-bind="dragOptions"
                      v-model="home.fileListNotesBanner.list"
                      @choose="setItemIndex"
                      tag="ul"
                      class="list"
                    >
                      <li
                        class="item "
                        v-for="(item, index) in home.fileListNotesBanner.list"
                        :key="index"
                      >
                        <div class="img">
                          <el-upload
                            class="BannerUpload"
                            ref="fileListNotesBanner"
                            action="/"
                            accept=".jpg,.jpeg,.png"
                            :on-change="_handleAddItemData.bind(null, item)"
                            :on-remove="_handleRemove.bind(null, item)"
                            :http-request="_appendFormDataInfo.bind(null, item)"
                            :file-list="item.img"
                            list-type="picture-card"
                            :drag="true"
                            :auto-upload="false"
                          >
                            <i class="el-icon-plus" />
                          </el-upload>
                        </div>
                        <div class="input">
                          <el-input
                            type="text"
                            v-model="item.link"
                            required
                            placeholder="请输入SKU/商品名称/链接地址"
                            clearable
                          />
                        </div>
                        <i
                          v-permission:del="$route.meta.permission"
                          class="iconfont icon-shanchu"
                          @click="delItem(home.fileListNotesBanner.list)"
                        />
                      </li>
                    </draggable>
                    <el-button
                      class="iconfont icon-xinzeng"
                      v-permission:add="$route.meta.permission"
                      @click="
                        moduleAddItem(
                          home.fileListNotesBanner.list,
                          'banner',
                          8
                        )
                      "
                    >
                      添加
                    </el-button>
                    <p class="tips">
                      *图片宽度640px，高度384px，支持JPG/PNG格式
                    </p>
                    <el-button
                      size="98"
                      class="sub-color"
                      v-permission:save="$route.meta.permission"
                      @click="
                        moduleSaveData(
                          home.fileListNotesBanner,
                          'fileListNotesBanner'
                        )
                      "
                    >
                      保存
                    </el-button>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="精选笔友模块" name="2">
                  <div class="editor">
                    <p class="icon-num_select">
                      <el-radio-group
                        @change="automatinRecommend"
                        v-model="home.fileListNotesPenfriend.type"
                      >
                        <el-radio label="1">手动推荐</el-radio>
                        <el-radio label="2">系统推荐</el-radio>
                      </el-radio-group>
                    </p>
                    <draggable
                      v-bind="dragOptions"
                      v-model="home.fileListNotesPenfriend.list"
                      @choose="setItemIndex"
                      tag="ul"
                      class="list"
                    >
                      <li
                        class="item nav wrap"
                        v-for="(item, index) in home.fileListNotesPenfriend
                          .list"
                        :key="index"
                      >
                        <div class="img radius">
                          <img :src="item.avatar" alt="" />
                        </div>
                        <div class="input">
                          <el-input
                            type="text"
                            v-model="item.name"
                            class="name"
                            required
                            clearable
                            @blur="getSommlier(item, 'name')"
                            placeholder="请输入品酒师名称"
                          />
                          <span class="level winemark ">
                            {{ item.level | formatWineType }}
                          </span>
                          <el-input
                            type="text"
                            v-model="item.id"
                            required
                            @blur="getSommlier(item, 'id')"
                            placeholder="请输入品酒师ID"
                            clearable
                          />
                        </div>
                        <i
                          v-permission:del="$route.meta.permission"
                          class="iconfont icon-shanchu"
                          @click="delItem(home.fileListNotesPenfriend.list)"
                        />
                      </li>
                    </draggable>
                    <el-button
                      class="iconfont icon-xinzeng"
                      v-permission:add="$route.meta.permission"
                      @click="
                        moduleAddItem(
                          home.fileListNotesPenfriend.list,
                          'notesPenfriend',
                          10
                        )
                      "
                    >
                      添加
                    </el-button>
                    <p class="tips">
                      *会员头像为系统自动生成，只需输入会员ID后系统反填会员名称和
                      会员头像。
                    </p>
                    <el-button
                      size="98"
                      class="sub-color"
                      v-permission:save="$route.meta.permission"
                      @click="
                        moduleSaveData(
                          home.fileListNotesPenfriend,
                          'fileListNotesPenfriend'
                        )
                      "
                    >
                      保存
                    </el-button>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="品酒笔记模块" name="3">
                  <div class="editor">
                    <ul class="nav-list">
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'find'"
                        :class="
                          home.fileListNotes.active === 'find' && 'active'
                        "
                      >
                        发现
                      </li>
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'attention'"
                        :class="
                          home.fileListNotes.active === 'attention' && 'active'
                        "
                      >
                        关注
                      </li>
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'hot'"
                        :class="home.fileListNotes.active === 'hot' && 'active'"
                      >
                        热点
                      </li>
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'celebrity'"
                        :class="
                          home.fileListNotes.active === 'celebrity' && 'active'
                        "
                      >
                        名人
                      </li>
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'sommelier'"
                        :class="
                          home.fileListNotes.active === 'sommelier' && 'active'
                        "
                      >
                        品酒师
                      </li>
                      <li
                        class="nav-item"
                        @click="home.fileListNotes.active = 'wineMerchant'"
                        :class="
                          home.fileListNotes.active === 'wineMerchant' &&
                            'active'
                        "
                      >
                        酒商
                      </li>
                    </ul>
                    <fragment
                      v-for="(value, field) in home.fileListNotes.field"
                      :key="field"
                    >
                      <draggable
                        v-show="field === home.fileListNotes.active"
                        v-bind="dragOptions"
                        v-model="
                          home.fileListNotes.field[home.fileListNotes.active]
                        "
                        @choose="setItemIndex"
                        tag="ul"
                        class="list"
                      >
                        <li
                          class="item nav wrap"
                          v-for="(item, index) in value"
                          :key="index"
                        >
                          <div class="img radius">
                            <img :src="item.avatar" alt="" />
                          </div>
                          <div class="input">
                            <el-input
                              type="text"
                              v-model="item.name"
                              class="name"
                              required
                              clearable
                              @blur="getSommlier(item, 'name')"
                              placeholder="请输入品酒师名称"
                            />
                            <span class="level winemark ">
                              {{ item.level | formatWineType }}
                            </span>
                            <el-input
                              type="text"
                              class="id"
                              v-model="item.id"
                              required
                              @blur="getSommlier(item, 'id')"
                              placeholder="请输入品酒师ID"
                              clearable
                            />
                            <div class="pel-level">
                              <i class="iconfont icon-v" />
                              <i class="level">{{ item.pelLevel }}</i>
                            </div>
                          </div>
                          <i
                            class="iconfont icon-shanchu"
                            v-permission:del="$route.meta.permission"
                            @click="
                              delItem(
                                home.fileListNotes.field[
                                  home.fileListNotes.active
                                ]
                              )
                            "
                          />
                          <div class="select-box">
                            <div class="select-img">
                              <el-upload
                                class="BannerUpload"
                                ref="fileListNotes"
                                action="/"
                                accept=".jpg,.jpeg,.png"
                                :on-change="_handleAddItemData.bind(null, item)"
                                :on-remove="_handleRemove.bind(null, item)"
                                :http-request="
                                  _appendFormDataInfo.bind(null, item)
                                "
                                :file-list="item.img"
                                list-type="picture-card"
                                :drag="true"
                                :auto-upload="false"
                              >
                                <i class="el-icon-plus" />
                                <span class="txt">选择封面</span>
                              </el-upload>
                            </div>
                            <div
                              class="select-note"
                              @click="selectNotes(item.id, index)"
                            >
                              <p v-if="!item.content">
                                <i class="el-icon-plus" />
                                <span class="txt">选择笔记</span>
                              </p>
                              <div class="content" v-else>
                                {{ item.content }}
                              </div>
                            </div>
                          </div>
                        </li>
                      </draggable>
                    </fragment>
                    <el-button
                      v-permission:add="$route.meta.permission"
                      class="iconfont icon-xinzeng"
                      @click="moduleAddItem('', 'notes', 10)"
                    >
                      添加
                    </el-button>
                    <p class="tips">
                      *会员头像为系统自动生成，只需输入会员ID后系统反填会员名称和
                      会员头像。
                    </p>
                    <el-button
                      size="98"
                      class="sub-color"
                      v-permission:save="$route.meta.permission"
                      @click="
                        moduleSaveData(home.fileListNotes, 'fileListNotes')
                      "
                    >
                      保存
                    </el-button>
                    <div class="hide-note__list" v-if="dialogVisibleNote">
                      <el-dialog
                        v-load="{ el: '.el-dialog__body', func: loadNotes }"
                        :visible.sync="dialogVisibleNote"
                        :modal-append-to-body="false"
                        :center="true"
                        :top="top"
                        width="98%"
                      >
                        <ul class="list">
                          <li
                            class="note-item"
                            v-for="item in notes"
                            :key="item.noteId"
                          >
                            <el-radio
                              v-model="
                                home.fileListNotes.field[
                                  home.fileListNotes.active
                                ][index].noteId
                              "
                              :label="item.noteId"
                            />
                            <div class="content">
                              <p class="time">
                                {{ item.time }}
                              </p>
                              <p class="txt">
                                {{ item.content }}
                              </p>
                            </div>
                          </li>
                        </ul>
                        <span class="winner-flex" v-if="notes.length === 0">
                          暂无笔记~！赶快去添加吧
                        </span>
                        <span slot="footer" class="dialog-footer">
                          <el-button
                            size="98"
                            class="sub-color"
                            @click="confirmNotes"
                          >
                            确 定
                          </el-button>
                        </span>
                      </el-dialog>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-Scrollbar>
          </div>
        </div>
      </div>
    </el-Scrollbar>
  </div>
</template>

<script>
import components from 'components/scanDecorationComponents.js'
import decorationAppMxins from '../../Mixins/'
import utils from '@/common/js/utils'

const _debounce = utils._debounce

export default {
  name: 'notes',
  mixins: [decorationAppMxins],
  props: {
    home: {
      type: Object,
      default: () => {
        return {}
      }
    },
    appletsId: {
      type: String
    },
    renovationType: {
      type: String
    }
  },
  data() {
    this.keyMap = {
      winemaker_list: {
        name: 'list',
        member_name: 'name',
        member_avatar: 'avatar',
        member_id: 'id',
        winemaker_type: 'level',
        type_level_id: 'pelLevel'
      },
      notes_list: {
        name: 'list',
        note_content: 'content',
        note_id: 'noteId',
        add_time: 'time'
      }
    }
    // 模块选择排序
    const componentClassify = ['Banner1', 'Penfriend1', 'Notes1']
    let compSelect = [
      {
        component: '',
        title: '01轮播banner图模块',
        index: '1',
        props: 'fileListNotesBanner'
      },
      {
        component: '',
        title: '02精选笔友模块',
        index: '2',
        props: 'fileListNotesPenfriend'
      },
      {
        component: '',
        title: '03品酒笔记模块',
        index: '3',
        props: 'fileListNotes'
      }
    ]
    componentClassify.forEach((v, i) => {
      components.forEach(vm => {
        if (vm[v] !== undefined) {
          compSelect[i].component = vm[v]
        }
      })
    })
    return {
      top: '',
      componentSelect: compSelect,
      dialogVisibleNote: false,
      notes: []
    }
  },
  methods: {
    /**
     * 选择笔记
     * @params id
     * @params index
     */
    selectNotes(id, index) {
      if (!id) return
      this.top = `${180 * index}px`
      this.currentPage = 1
      this.notesId = id
      this.notes = []
      this.getNotesList(id)
    },
    /**
     * 获取笔记
     * @params id
     * @params index
     */
    getNotesList(id) {
      this.api
        .getNotesList({
          member_id: id,
          curpage: this.currentPage
        })
        .then(res => {
          this.pageCount = res.page_count
          this.utils._modifyObjKey(res, this.keyMap)
          this.notes = [...this.notes, ...res.list]
          this.dialogVisibleNote = true
        })
    },

    /**
     * 下拉加载笔记
     * @params id
     * @params index
     */
    loadNotes: _debounce(function() {
      if (this.currentPage >= this.pageCount) return
      this.currentPage++
      this.getNotesList(this.notesId)
    }, 100),
    /**
     * 确认笔记
     */
    confirmNotes() {
      if (this.notes.length === 0) {
        this.dialogVisibleNote = false
        return
      }
      const notes = this.home.fileListNotes.field
      const active = this.home.fileListNotes.active
      const noteId = notes[active][this.index].noteId
      const selectCurrent = this.notes.find(v => {
        return v.noteId === noteId
      })
      notes[active][this.index].content = selectCurrent.content
      this.dialogVisibleNote = false
      this.notes = []
    },
    /**
     * 自动推荐
     */
    automatinRecommend(val) {
      if (val === '2') {
        this.api.systemRecSommelier().then(res => {
          this.utils._modifyObjKey(res, this.keyMap)
          this.home.fileListNotesPenfriend.list = res.list
        })
      } else {
        this.home.fileListNotesPenfriend.list = []
        this.moduleAddItem(
          this.home.fileListNotesPenfriend.list,
          'notesPenfriend',
          4
        )
      }
    },
    /**
     * 获取品酒师
     * @param item
     * @param type
     */
    getSommlier(item, type) {
      let data = {
        audit_status: 2
      }
      if (type === 'name') {
        data.member_name = item.name
      } else {
        data.member_id = item.id
      }
      this.api.getSommelierList(data).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        if (res.list[0]) Object.assign(item, res.list[0])
        else
          for (let key in item) {
            if (key === 'img') item[key] = []
            else item[key] = ''
          }
      })
    }
  }
}
</script>
